import { BaseSyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import ClassPicker from 'src/components/class-picker';
import { useCommonXapiContextPayloadHook } from 'src/hooks/use-common-xapi-context-payload.hook';
import { XApiEventKeys } from 'src/interfaces/event.types';
import { getAmpConfig } from 'src/services/amp-config.service';
import eventService from 'src/services/event.service';

import 'src/components/top-banner/top-banner.scss';

export const TopBanner = () => {
  const { t } = useTranslation();
  const redirectUrl = getAmpConfig().educatorHome;

  const commonXapiContextPayload = useCommonXapiContextPayloadHook();

  const handleGoToEhClick = async (e: BaseSyntheticEvent, url: string) => {
    e.preventDefault();

    try {
      await eventService.send(XApiEventKeys.openedEducatorHome, undefined, {
        result: {
          isRightClick: e.type === 'contextmenu',
          ...commonXapiContextPayload,
        },
      });
    } catch (error) {
      console.error('Error sending go to EH xAPI event:', error);
    } finally {
      if (e.type !== 'contextmenu') {
        window.location.assign(url);
      }
    }
  };

  return (
    <div className="top-banner">
      <div className="top-banner__left">
        <a
          href={redirectUrl}
          className="top-banner__home-button"
          onClick={(e) => handleGoToEhClick(e, redirectUrl)}
          onContextMenu={(e) => handleGoToEhClick(e, redirectUrl)}
        >
          {t('Back')}
        </a>
        <div className="top-banner__vertical-divider" />
        <h2 className="top-banner__title">{t('Student Preview Mode')}</h2>
      </div>
      <div className="top-banner__right">
        <ClassPicker />
      </div>
    </div>
  );
};
